import script from "./premium.vue?vue&type=script&setup=true&lang=js"
export * from "./premium.vue?vue&type=script&setup=true&lang=js"

import "./premium.vue?vue&type=style&index=0&id=236d0b98&lang=scss"

const __exports__ = script;

export default __exports__